//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import Footer from '../components/footer.vue'
    import {
        SaunaKanbanQuery,
        MemberKanbanQuery
    } from '../../static/js/api.js'

    function loadtotal(that) {


        SaunaKanbanQuery({}, function (res) {
            console.log(res)
            if (res.data.IsSuccess) {

                that.data = JSON.parse(res.data.Result)


                MemberKanbanQuery({}, function (ress) {
                    console.log(ress)
                    if (ress.data.IsSuccess) {

                        that.data.PayDetails = JSON.parse(ress.data.Result).PayDetails
                        console.log(that.data)
                    } else {

                        that.$vux.toast.text('数据获取失败，请重试', 'middle')

                    }


                })



                that.loading=false

                console.log(that.data)
            } else {

                that.$vux.toast.text('数据获取失败，请重试', 'middle')

            }


        })

    }


    export default {
        name: 'app',
        components: {
            'pc-footer': Footer,
        },
        data() {
            return {
                loading:true,
                data: {
                    GuestFlows: {},
                    BarConsumeDetails: {},
                    BarConsumeSummary: {},
                    ConsumeDetails: {},
                    ConsumeSummary: {},
                    GuestPerConsume: {},
                    HandCardUsed: {},
                    MemberUsedDetail: {},
                    MemberUsedSummary: {},
                    NewMemberDetails: {},
                    NewMemberSummary: {},
                    PayModeDetails: {},
                    PayModeSummary: {
                        Money:1
                    },
                    PrepaidMemberDetails: {},
                    PrepaidMemberSummary: {},
                    PayDetails: {},

                },
                selected:1,
                selectedsr:1,
                msg: 'Welcome to Your Vue.js App',
                nav:[
                    {
                        id:1,
                        name:"人数统计"

                    },
                    {
                        id:2,
                        name:"收入情况"

                    },
                    {
                        id:3,
                        name:"销售类别"

                    },{
                        id:4,
                        name:"吧台统计"

                    }

                ],
                navsr:[
{
                        id:1,
                        name:"会员续费"

                    }


                ]
            }
        },

        created() {
            var that = this
            loadtotal(that)


        },
        methods:{

            refresh(){
                this.loading=true
                var that=this
                loadtotal(that)


            },
            change(index){
                console.log(index)
                this.selected= parseInt(index+1)

            },

            changesr(index){
                console.log(index)
                this.selectedsr= parseInt(index+1)

            }


        }

    }



// WEBPACK FOOTER //
// ./src/pages/mainclass3.vue